export var Config =
      {
		  host: 'http://s.chaseandcoadvertising.co.uk:84/',
		  server: 'chaseportal_server/' ,
		  version: 'v1/',
		  oauth: 'oauth2/' ,
		  extensions: 'extensions/',
		  connections:{}
};
